<template>
<div class="yjtx">
  <div class="close" @click="closeyjtx">
    <img src="../../../assets/home/icon_close.png" alt="">
  </div>
  <div class="page1">
    <p><em>单位名称</em> <span>{{ deptName }}</span></p>
    <p><span class="firpageTitle">监测点名称</span> <span class="pageTitle" style="width: 40%">隐患名称</span> <span class="pageTitle">隐患等级</span> </p>
    <p v-for="item in tableList"><span class="firpageNr">{{ item.monitorName }}</span>
      <span class="pageNr" style="width: 40%">{{ item.alertLevelNames.join(',') }}</span>
      <span class="pageNr" >
      {{ item.mostSeriousRiskLevelName }}
</span> <span class="pageNr"></span></p>
<!--    <p><em>检测名称:</em> <span>ssmm</span></p>
    <p><em><b>时</b><b>间:</b></em><span>2022年10月28日12时45分45秒</span></p>
    <p><em>设备状态: </em><span>运行正常</span></p>
    <p><em>地理位置: </em><span>上海市松江区广富林路568号松江万达</span></p>-->
  </div>
</div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
export default {
  props: {
    depid: {
      type: Number,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      tableList:[],
      deptName:"",
    }
  },

  methods: {
    jumpStation(item) {
      this.$router.push({
        name: "stationListPage",
        params: {
          val: [
            item.monitorName + "详情",
            item.branchId,
            item.monitorId,
            "/dataDetail",
          ],
        },
      });
      Bus.$emit("changeheader", "2");
    },
    getColor(row) {
      switch (row.riskLevel || row.mostSeriousRiskLevel) {
        case 5:
          return ["color:#D61E1E", "重大风险"];
        case 4:
          return ["color:#EA8100", "较大风险"];
        case 3:
          return ["color:#CBB000", "一般风险"];
        case 2:
          return ["color:#0B47A5", "早期风险"];
        case 1:
          return ["color:#008B61", "正常"];
        case 6:
          return ["color: #7D879F", "误报源"];
        default:
          return ["color: #7D879F", "误报源"];
      }
    },
    closeyjtx() {

      this.$emit('opencqyj')
    },
    queryRealtimeList(id) {
      const param = {
        url: "/portal/realtimeRisks",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.tableList = res.data;
          console.log(this.tableList)

        }

      });
    },

  },
  mounted() {
    let that=this
    Bus.$on("changeid", (val) => {

      that.deptName=val.deptName
      that.queryRealtimeList(val.deptId)

    });
  },
  watch:{
    depid(){
      console.log('6666')

    }
  }
}
</script>

<style lang="scss" scoped>
.yjtx {
  background: url("../../../assets/home/item6_popbg1.png") no-repeat;
  width: 600px;
  height: 362px;
  padding: 20px 0;
  background-size: 100% 100%;
  position: absolute;
  left: -3px;
  top: 60px;
  display: flex;
  z-index: 100;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
  pointer-events: initial;
  .close {
    width: 17px;
    height: 17px;
    position: absolute;
    right: 5px;
    top: -4px;
    z-index: 100;
  }
}

.page1 {
  margin-left: 20px;
  padding-top: 30px;
  width: 100%;
  max-height: 800px;
  overflow: auto;
  p {
    font-size: 18px;
    font-family: PingFang;
    font-weight: 500;
    color: rgba(#01A3FF, 0.6);
    line-height: 24px;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: flex-start;
    em {
      font-style: normal;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
    }

    span {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: #CDF7FF;
    }
    .pageTitle {
      font-size: 18px;
      width: 20%;
    }
    .firpageTitle {
      font-size: 18px;
      width: 40%;
    }
    .pageNr {
      font-size: 16px;
      width: 20%;
      a {
      }
    }
    .firpageNr{
      font-size: 16px;
      width: 40%;
    }
  }
}
</style>
